import styled from "styled-components";
import {
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_SM_BP,
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	MOBILE_L_BP,
	COLOR_HYPERLINK,
	COLOR_BORDER_LIGHT_GREY,
	COLOR_WHITE,
	COLOR_BACKGROUND_GREEN,
	MOBILE_M_BP,
	COLOR_HIGHLIGHT_GREY,
} from "@website-builder/utilities-index";

export const JobsWrapper = styled.div`
	padding: 60px 0px 60px 0px;
	.heading {
		text-align: center;
		font-size: 28px;
		font-weight: ${FONT_WT_MEDIUM};
		color: ${COLOR_TEXT_PRIMARY_B2C};
		margin-bottom: 30px;
	}
	.filterContainer {
		display: flex;
		justify-content: center;
		flex-flow: wrap;
		padding-bottom:;
	}
	.teamSelect {
		outline: none;
		margin-right: 10px;
		width: 230px;
		height: 48px;
		padding: 12px 10px 12px 24px;
		border-radius: 3px;
		box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
		border: solid 1px ${COLOR_BORDER_LIGHT_GREY};
		font-size: 18px;
		font-weight: ${FONT_WT_LIGHT};
		color: ${COLOR_TEXT_PRIMARY_B2C};
	}
	.locationSelect {
		outline: none;
		margin-right: 10px;
		width: 230px;
		height: 48px;
		padding: 12px 10px 12px 24px;
		border-radius: 3px;
		box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
		border: solid 1px ${COLOR_BORDER_LIGHT_GREY};
		font-size: 18px;
		font-weight: ${FONT_WT_LIGHT};
		color: ${COLOR_TEXT_PRIMARY_B2C};
	}
	.jobSelect {
		outline: none;
		margin-right: 10px;
		width: 230px;
		height: 48px;
		padding: 12px 10px 12px 24px;
		border-radius: 3px;
		box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
		border: solid 1px ${COLOR_BORDER_LIGHT_GREY};
		font-size: 18px;
		font-weight: ${FONT_WT_LIGHT};
		color: ${COLOR_TEXT_PRIMARY_B2C};
	}
	.teamType {
		padding-bottom: 10px;
		position: relative;
		.Dropdown-root {
			margin-right: 10px;
			box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
			.Dropdown-control {
				height: 48px !important;
				width: 230px;
				padding: 12px 30px 12px 10px;
				font-size: 18px;
				font-weight: ${FONT_WT_LIGHT};
				color: ${COLOR_TEXT_PRIMARY_B2C};
				border-radius: 3px;
				border: solid 1px ${COLOR_BORDER_LIGHT_GREY};
				.Dropdown-arrow {
					top: 20px;
				}
			}
			.Dropdown-menu {
				border-top: none;
				border-right: solid 1px ${COLOR_BORDER_LIGHT_GREY};
				border-bottom: solid 1px ${COLOR_BORDER_LIGHT_GREY};
				border-left: solid 1px ${COLOR_BORDER_LIGHT_GREY};
				.Dropdown-option {
					padding: 15px 10px;
					font-size: 18px;
					font-weight: ${FONT_WT_LIGHT};
					color: ${COLOR_TEXT_PRIMARY_B2C};
					:hover {
						background-color: ${COLOR_HIGHLIGHT_GREY};
						color: ${COLOR_TEXT_PRIMARY_B2C};
					}
				}
				.Dropdown-option.is-selected {
					background-color: ${COLOR_HIGHLIGHT_GREY};
					color: ${COLOR_TEXT_PRIMARY_B2C};
					font-size: 18px;
					font-weight: ${FONT_WT_LIGHT};
				}
			}
		}
	}
	.location {
		padding-bottom: 10px;
		position: relative;
		.Dropdown-root {
			margin-right: 10px;
			box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
			.Dropdown-control {
				height: 48px !important;
				width: 230px;
				padding: 12px 30px 12px 10px;
				font-size: 18px;
				font-weight: ${FONT_WT_LIGHT};
				color: ${COLOR_TEXT_PRIMARY_B2C};
				border-radius: 3px;
				border: solid 1px ${COLOR_BORDER_LIGHT_GREY};
				.Dropdown-arrow {
					top: 20px;
				}
				.Dropdown-placeholder {
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
			}
			.Dropdown-menu {
				border-top: none;
				border-right: solid 1px ${COLOR_BORDER_LIGHT_GREY};
				border-bottom: solid 1px ${COLOR_BORDER_LIGHT_GREY};
				border-left: solid 1px ${COLOR_BORDER_LIGHT_GREY};
				.Dropdown-option {
					padding: 15px 10px;
					font-size: 18px;
					font-weight: ${FONT_WT_LIGHT};
					color: ${COLOR_TEXT_PRIMARY_B2C};
					:hover {
						background-color: ${COLOR_HIGHLIGHT_GREY};
						color: ${COLOR_TEXT_PRIMARY_B2C};
					}
				}
				.Dropdown-option.is-selected {
					background-color: ${COLOR_HIGHLIGHT_GREY};
					color: ${COLOR_TEXT_PRIMARY_B2C};
					font-size: 18px;
					font-weight: ${FONT_WT_LIGHT};
				}
			}
		}
	}
	.jobType {
		padding-bottom: 10px;
		position: relative;
		.Dropdown-root {
			margin-right: 10px;
			box-shadow: 0 5px 10px 0 rgba(0, 0, 0, 0.05);
			.Dropdown-control {
				height: 48px !important;
				width: 230px;
				padding: 12px 30px 12px 10px;
				font-size: 18px;
				font-weight: ${FONT_WT_LIGHT};
				color: ${COLOR_TEXT_PRIMARY_B2C};
				border-radius: 3px;
				border: solid 1px ${COLOR_BORDER_LIGHT_GREY};
				.Dropdown-arrow {
					top: 20px;
				}
			}
			.Dropdown-menu {
				border-top: none;
				border-right: solid 1px ${COLOR_BORDER_LIGHT_GREY};
				border-bottom: solid 1px ${COLOR_BORDER_LIGHT_GREY};
				border-left: solid 1px ${COLOR_BORDER_LIGHT_GREY};
				.Dropdown-option {
					padding: 15px 10px;
					font-size: 18px;
					font-weight: ${FONT_WT_LIGHT};
					color: ${COLOR_TEXT_PRIMARY_B2C};
					:hover {
						background-color: ${COLOR_HIGHLIGHT_GREY};
						color: ${COLOR_TEXT_PRIMARY_B2C};
					}
				}
				.Dropdown-option.is-selected {
					background-color: ${COLOR_HIGHLIGHT_GREY};
					color: ${COLOR_TEXT_PRIMARY_B2C};
					font-size: 18px;
					font-weight: ${FONT_WT_LIGHT};
				}
			}
		}
	}
	.dataWrapper {
		text-align: center;
		margin-top: 30px;
		ul {
			padding: 0px;
			list-style-type: none;
			li:nth-child(odd) {
				background: ${COLOR_BACKGROUND_GREEN};
			}
			li:nth-child(even) {
				background: ${COLOR_WHITE};
			}
			li {
				padding: 17px 10px 18px 10px;
				cursor: pointer;
				display: flex;
				justify-content: space-evenly;
				span {
					display: block;
					float: left;
					width: 200px;
					justify-content: space-evenly;
					text-align: left;
				}
				a {
					text-decoration: none;
				}
				.break {
					display: none;
				}
			}
		}
		.jobRole {
			color: ${COLOR_HYPERLINK};
			font-size: 16px;
			font-weight: ${FONT_WT_MEDIUM};
			margin-right: 50px;
			width: 250px;
		}
		.jobDetail {
			color: ${COLOR_TEXT_PRIMARY_B2C};
			font-size: 16px;
			font-weight: ${FONT_WT_LIGHT};
			padding-left: 10px;
			padding-right: 10px;
		}
	}
	.openRoles {
		text-align: center;
		color: ${COLOR_TEXT_PRIMARY_B2C};
		margin-top: 25px;
	}
	.filterWrapper {
		cursor: pointer;
		display: flex;
		picture {
			img {
				padding-top: 14px;
				padding-right: 5px;
			}
		}
	}
	.clearFilterButton {
		padding-top: 15px;
		color: ${COLOR_TEXT_PRIMARY_B2C};
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		.dataWrapper {
			ul {
				li {
					padding: 17px 10px 18px 80px;
					span {
						width: 180px !important;
					}
				}
			}
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		.teamType {
			margin: auto;
		}
		.location {
			margin: auto;
		}
		.jobType {
			margin: auto;
		}
		.filterContainer {
			flex-flow: column;
			text-align: center;
		}
		.filterWrapper {
			justify-content: center;
		}
		.dataWrapper {
			ul {
				li {
					height: auto;
					justify-content: space-evenly;
					flex-flow: column;
					display: grid;
					padding: 20px 0px 20px 0px;
					span {
						flex-flow: wrap;
						width: 150px;
						text-align: left;
						padding-top: 5px;
						padding-bottom: 5px;
						padding-right: 10px;
						padding-left: 15px;
					}
					.break {
						display: inline-block;
					}
				}
			}
			.jobRole {
				margin-right: 0px;
				overflow: hidden;
			}
			.jobDetail {
				padding-left: 15px;
			}
		}
	}

	@media only screen and (max-width: ${MOBILE_M_BP}px) {
		.dataWrapper {
			ul {
				li {
					span {
						width: 140px !important;
					}
				}
			}
		}
	}
`;

export const ButtonWrapper = styled.div`
	text-align: center;
	margin-top: 35px;
	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		button {
			padding: 0 20px;
		}
	}
`;
